/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Download_Brave_ButtonInputs */

const en_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Brave`)
};

const id_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengunduh Brave`)
};

const ms_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat turun Brave`)
};

const ca_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar Brave`)
};

const cs_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout Brave`)
};

const da_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Brave`)
};

const de_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Herunterladen`)
};

const et_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lae Brave alla`)
};

const es_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar Brave`)
};

const fr_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger Brave`)
};

const hr_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preuzmite Brave`)
};

const it_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica Brave`)
};

const lv_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lejupielādējiet Brave`)
};

const lt_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atsisiųsti „Brave“`)
};

const hu_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave letöltése`)
};

const nl_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave downloaden`)
};

const nb_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last ned Brave`)
};

const pl_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz Brave`)
};

const pt_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Download`)
};

const ro_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarcă Brave`)
};

const sk_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stiahnite si Brave`)
};

const sl_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenesite Brave`)
};

const fi_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa Brave`)
};

const sv_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ner Brave`)
};

const vi_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải xuống Brave`)
};

const tr_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave'i indirin`)
};

const el_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λήψη Brave`)
};

const bg_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтегли Brave`)
};

const ru_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать браузер Brave`)
};

const sr_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преузми Brave`)
};

const uk_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажити Brave`)
};

const ka_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave-ის გადმოწერა`)
};

const hi_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave डाउनलोड करें`)
};

const th_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดาวน์โหลด Brave`)
};

const ko_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 다운로드`)
};

const zh_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 Brave`)
};

const zh_tw_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下載 Brave`)
};

const ja_download_brave_button = /** @type {(inputs: Download_Brave_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braveをダウンロード`)
};

/**
* | output |
* | --- |
* | "Download Brave" |
*
* @param {Download_Brave_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const download_brave_button = /** @type {((inputs?: Download_Brave_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Download_Brave_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_download_brave_button(inputs)
	if (locale === "ms") return ms_download_brave_button(inputs)
	if (locale === "ca") return ca_download_brave_button(inputs)
	if (locale === "cs") return cs_download_brave_button(inputs)
	if (locale === "da") return da_download_brave_button(inputs)
	if (locale === "de") return de_download_brave_button(inputs)
	if (locale === "et") return et_download_brave_button(inputs)
	if (locale === "es") return es_download_brave_button(inputs)
	if (locale === "fr") return fr_download_brave_button(inputs)
	if (locale === "hr") return hr_download_brave_button(inputs)
	if (locale === "it") return it_download_brave_button(inputs)
	if (locale === "lv") return lv_download_brave_button(inputs)
	if (locale === "lt") return lt_download_brave_button(inputs)
	if (locale === "hu") return hu_download_brave_button(inputs)
	if (locale === "nl") return nl_download_brave_button(inputs)
	if (locale === "nb") return nb_download_brave_button(inputs)
	if (locale === "pl") return pl_download_brave_button(inputs)
	if (locale === "pt") return pt_download_brave_button(inputs)
	if (locale === "ro") return ro_download_brave_button(inputs)
	if (locale === "sk") return sk_download_brave_button(inputs)
	if (locale === "sl") return sl_download_brave_button(inputs)
	if (locale === "fi") return fi_download_brave_button(inputs)
	if (locale === "sv") return sv_download_brave_button(inputs)
	if (locale === "vi") return vi_download_brave_button(inputs)
	if (locale === "tr") return tr_download_brave_button(inputs)
	if (locale === "el") return el_download_brave_button(inputs)
	if (locale === "bg") return bg_download_brave_button(inputs)
	if (locale === "ru") return ru_download_brave_button(inputs)
	if (locale === "sr") return sr_download_brave_button(inputs)
	if (locale === "uk") return uk_download_brave_button(inputs)
	if (locale === "ka") return ka_download_brave_button(inputs)
	if (locale === "hi") return hi_download_brave_button(inputs)
	if (locale === "th") return th_download_brave_button(inputs)
	if (locale === "ko") return ko_download_brave_button(inputs)
	if (locale === "zh") return zh_download_brave_button(inputs)
	if (locale === "zh-tw") return zh_tw_download_brave_button(inputs)
	if (locale === "ja") return ja_download_brave_button(inputs)
	return en_download_brave_button(inputs)
});